import { cn } from '../../lib/utils'
import { useStatusLabel, type StatusKind } from '../../i18n/statusLabels'

const statusStyles: Record<string, string> = {
  active: 'bg-success/20 text-success',
  ended: 'bg-text-muted/20 text-text-secondary',
  error: 'bg-error/20 text-error',
}

export function StatusBadge({ status, kind = 'call' }: { status: string; kind?: StatusKind }) {
  const label = useStatusLabel(status, kind)
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', statusStyles[status] || statusStyles.ended)}>
      {status === 'active' && <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-success animate-pulse" />}
      {label}
    </span>
  )
}
